/**
 * Focus treatment shared by every interactive element of the desktop
 * navigation. Kept in one place because the string is long enough that copies
 * drift apart silently.
 */
export const focusRing = 'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-deep-teal-700 purple-theme:focus-visible:ring-purple-700';

/**
 * Trigger styling shared by the account and language menus. Figma builds both
 * from the same `main.navi.item` component as the navigation entries, so they
 * share its type treatment: regular weight, semibold on hover.
 */
export const utilityTrigger = `inline-flex items-center gap-1.5 text-base rounded-md text-deep-teal-700 purple-theme:text-purple-700 hover:text-deep-teal-900 purple-theme:hover:text-purple-900 hover:font-semibold transition-colors ${focusRing}`;
